import React from 'react';
import PropTypes from 'prop-types';

import './LoadingAnimation.less';

/**
 * Displays a simple SVG "loading" animation.
 */
const LoadingAnimation = ({ loadingMessage, size, colorized }) => (
  <div className="LoadingAnimation">
    {!!loadingMessage && (
      <p className="loading_message">
        {loadingMessage}
      </p>
    )}
    <svg className="spinner" width={`${size}px`} height={`${size}px`} viewBox={`0 0 ${size} ${size}`} xmlns="http://www.w3.org/2000/svg">
      <circle className={`path ${!colorized ? 'path_no_color' : ''}`} fill="none" strokeWidth={size / 11} strokeLinecap="round" cx={size / 2} cy={size / 2} r={(size / 2) * 0.75} />
    </svg>
  </div>
);

LoadingAnimation.propTypes = {
  /** Message that is displayed above the SVG animation. */
  loadingMessage: PropTypes.string,
  /** Diameter of the circle. */
  size: PropTypes.number,
  /** Should animation cycle through colors. */
  colorized: PropTypes.bool,
};

LoadingAnimation.defaultProps = {
  loadingMessage: null,
  size: 66,
  colorized: true,
};

export default LoadingAnimation;
